import { makeStyles, createStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const potentialStyles = makeStyles((theme: Theme) =>
    createStyles({
        overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            minHeight: "100vh",
            width: "100%",
            zIndex: 1201,
        },
        errorLegend: {
            display: "flex",
            position: "absolute",
            top: "10px",
            padding: "5px",
            color: theme.palette.warning.main,
            zIndex: 10,
            alignItems: "center",
        },
        infoIcon: {
            transform: "rotate(180deg)",
            cursor: "pointer !important",
            color: theme.palette.warning.main,
            zIndex: 10,
        },
    })
);

export default potentialStyles;
